import { render, staticRenderFns } from "./WriterFree.pug?vue&type=template&id=120a9726&external"
import script from "./WriterFree.js?vue&type=script&lang=js&external"
export * from "./WriterFree.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports